<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="save">
                    <div class="card">
                        <div class="card-header">
                            <i class="fas fa-list"></i> Menu
                        </div>
                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                              <div
                                  class="col-md-4"
                                  :class="{ 'dropdown-has-error': $v.model.id_pais.$error }"
                              >
                                  <label>País*</label>
                                  <select-api
                                      v-if="!model.id || model.id == 0"
                                      v-model="model.id_pais"
                                      :endpoint="'/pais/pesquisa'"
                                      :opt-text="'nome'"
                                      :select-option="true"
                                  ></select-api>

                                  <input
                                      v-if="model.id > 0"
                                      disabled
                                      :value="model.pais ? model.pais.nome : ''"
                                      type="text"
                                      maxlength="150"
                                      class="form-control"/>
                              </div>

                              <div
                                  class="col-md-4"
                                  :class="{ 'has-danger': $v.model.nome.$error }"
                              >
                                  <label>Nome*</label>
                                  <input
                                      type="text"
                                      maxlength="150"
                                      class="form-control"
                                      v-model="model.nome"
                                  />
                              </div>
                            </div>

                            <div class="form-group row">
                              <div class="col-md-6">
                                <label>Descrição</label>
                                <dw-textarea
                                    maxlength="250"
                                    v-model="model.descricao"
                                    @input="$v.model.descricao.$touch()"
                                ></dw-textarea>
                              </div>
                            </div>
                        </div>
                    </div>

                    <dw-select-add
                        ref="paginasComp"
                        :url-select="`pagina/pesquisa?id_pais=${model.id_pais}`"
                        :opt-text="'nome'"
                        :title="'Página'"
                        :model-name="'menu-pagina'"
                        :model-id="model.id"
                        :param-label="'nome'"
                        :param-name="'menu'"
                        :object-list="'paginas'"
                        :draggable="true"
                        :param-sort="'menuPagina.ordem'"
                        v-if="model.id"
                    ></dw-select-add>

                    <div class="card">
                        <div class="card-footer text-right">
                            <router-link
                                :to="{ name: 'list-menu' }"
                                class="btn btn-link"
                            >Cancelar</router-link>
                            <button type="submit" class="btn btn-primary">Salvar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Facade from "../../facade/facade";
const facade = new Facade();
import {
    required,
    minLength,
    maxLength,
    withParams,
    email
} from "vuelidate/lib/validators";
import {
    isNotUndefinedOrNullOrEmptyOrZero,
    isUndefinedOrNullOrEmpty
} from "@/services/string";
import SelectApi from "../../components/Input/SelectApi";
import FileImage from "../../components/Input/FileImage";
import { isPhone, isCpf, validateCPF } from "@/services/util";
import Collections from "../../helpers/collections";
import Select2 from '../../components/Input/Select2';
export default {
    components: {
        FileImage, Select2, SelectApi
    },
    data() {
        return {
            model: {
                id: null,
                nome: "",
                descricao: "",
                id_pais: ''
            }
        };
    },
    validations() {
        let vm = this;

        return {
            model: {
                nome: {
                    required,
                    minLength: minLength(2)
                },
                id_pais: {
                  required,
                  isNotUndefinedOrNullOrEmptyOrZero
                }
            }
        };
    },
    methods: {
        async save() {
            let vm = this;
            if (this.$v.model.$invalid) {
                this.$v.model.$touch();
                this.$notify.warning(
                    "Atenção!",
                    "Verifique se todos os campos estão preenchidos corretamente."
                );
                return;
            }

            this.$loading.show(true);

            try {
                if (vm.model.id) {
                    vm.model.paginas = vm.$refs.paginasComp.list;

                    await facade.updateMenu(vm.model, vm.model.id);
                    this.$router.push({ name: "list-menu" });
                } else {
                    let ret = await facade.createMenu(vm.model);
                    this.$router.push({name: 'edit-menu', params: {id: ret.data.data.id}});
                }

                this.$loading.show(false);
            } catch (e) {
                e.forEach(item => {
                    this.$notify.error(item.field, item.message);
                });
                this.$loading.show(false);
            }
        },
        throwError(e) {
            this.$notify.error("Erro!", e);
        },
        setData(model) {
            let vm = this;

            if (model !== undefined && model !== null) {
                vm.model = model;
                vm.corObjeto = vm.model.cor;
            }
        }
    },
    async beforeRouteEnter(to, from, next) {
        let menu = null;

        if (to.params.id) {
            menu = (await facade.getMenu(to.params.id)).data.data;
        }

        next(vm => vm.setData(menu));
    }
};
</script>



// WEBPACK FOOTER //
// Form.vue?73de736b